
import { Label } from "@/components/ui/label";
import { Input } from "@/components/ui/input";

interface FileNameFieldProps {
  value: string;
  onChange: (value: string) => void;
}

export function FileNameField({ value, onChange }: FileNameFieldProps) {
  return (
    <div>
      <Label htmlFor="file-name">Όνομα Αρχείου</Label>
      <Input 
        id="file-name"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        className="mt-1"
      />
    </div>
  );
}
